import React from "react";
import { EyeIcon, PencilIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import store, {
    setIsLoading,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setIsDisable,
} from "./store";
import { store as userStore } from "@components/VerticalLayout/store";

import { verifyIfPeripheralAssociate } from "../../../helpers/peripheralsHelpers";
import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import ErrorToast from "@components/Common/ErrorTost";

type CustomIconsType = {
    e: any;
    setShopId: Function;
    setRowData: Function;
    setMonetics: Function;
    setIsModalOpened: Function;
    isModalOpened: boolean;
    setMoneticId: Function;
    isModalDeleteAssociatePeripheralOpened: boolean;
    setIsModalDeleteAssociatePeripheralOpened: Function;
    setObjectApiUrlDissociate: Function;
    setInputIp: Function;
    setIsConfirmationEditRunning: Function;
    typeDisplay: any;
    setSelectedRows: Function;
    setIsHistoryModalOpened: Function;
    setIsConsult: Function;
    setIsAddMoneticsClicked: Function;
    isAddMoneticsClicked: boolean;
};
export function CustomIcons({
    e,
    setShopId,
    setRowData,
    setMonetics,
    setIsModalOpened,
    isModalOpened,
    setMoneticId,
    isModalDeleteAssociatePeripheralOpened,
    setIsModalDeleteAssociatePeripheralOpened,
    setObjectApiUrlDissociate,
    setInputIp,
    setIsConfirmationEditRunning,
    typeDisplay,
    setSelectedRows,
    setIsHistoryModalOpened,
    setIsConsult,
    setIsAddMoneticsClicked,
    isAddMoneticsClicked,
}: CustomIconsType) {
    const {
        isUpdateOperation,
        isActionsClicked,
        isEdited,
        modify,
        isLoading,
        isDisable,
    } = useSnapshot(store);
    const { userID, franchiseID } = useSnapshot(userStore);
    const { t } = useTranslation();
    const appId = "KIOSK";
    let ifPeripheralAssociateObject: {
        isPeripheralAssociate: boolean;
        appId_children: any[];
    };
    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined &&
                (modify === false || typeDisplay === "archived") && (
                    <div className="d-flex justify-content-around">
                        <Tooltip title={t("To consult").toString()}>
                            <div>
                                <Tooltip title={t("To consult").toString()}>
                                    <div>
                                        <ConsultSvgIcon
                                            className="cmn_icn_toConsult"
                                            height={35}
                                            width={35}
                                            onClick={() => {
                                                setIsConsult(true);
                                                setRowData(e.selectedRow);
                                                setShopId(e.selectedRow.shopId);
                                                setInputIp(false);
                                                setMonetics(e.selectedRow);
                                                if (!isAddMoneticsClicked) {
                                                    setIsAddMoneticsClicked(
                                                        !isAddMoneticsClicked
                                                    );
                                                }
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                position: "relative",
                                                bottom: "0px",
                                            }}
                                        />
                                    </div>
                                </Tooltip>
                            </div>
                        </Tooltip>
                    </div>
                )}
            {e.selectedRow?.subRows === undefined && modify === true ? (
                <div className="d-flex justify-content-around">
                    {typeDisplay === "notArchived" ? (
                        <Tooltip title={t("Edit").toString()}>
                            <div>
                                <PencilIcon
                                    onClick={() => {
                                        if (isEdited === true) {
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(() => {
                                                setIsDisable(true);
                                                setIsEdited(false);
                                                setRowData(e.selectedRow);
                                                setShopId(e.selectedRow.shopId);
                                                setInputIp(false);
                                                setMonetics(e.selectedRow);
                                                if (!isAddMoneticsClicked) {
                                                    setIsAddMoneticsClicked(
                                                        !isAddMoneticsClicked
                                                    );
                                                }
                                            });
                                        } else {
                                            setIsDisable(true);
                                            setRowData(e.selectedRow);
                                            setShopId(e.selectedRow.shopId);
                                            setInputIp(false);
                                            setMonetics(e.selectedRow);
                                            if (!isAddMoneticsClicked) {
                                                setIsAddMoneticsClicked(
                                                    !isAddMoneticsClicked
                                                );
                                            }
                                        }
                                    }}
                                    className={classnames("cmn_icn_edit ", {
                                        "not-allowed-icon__clz": isDisable,
                                    })}
                                    height={25}
                                    width={25}
                                    style={{
                                        cursor: !isAddMoneticsClicked
                                            ? "pointer"
                                            : "",
                                    }}
                                />
                            </div>
                        </Tooltip>
                    ) : null}

                    {typeDisplay === "notArchived" ? (
                        <Tooltip title={t("Archive").toString()}>
                            <div>
                                <TrashIcon
                                    className={`${classnames(
                                        "cmn_icn_FRarchived ml-2",
                                        {
                                            "not-allowed-icon__clz": isLoading,
                                        }
                                    )}`}
                                    onClick={async () => {
                                        setIsLoading(true);
                                        if (isEdited === true) {
                                            setIsLoading(false);
                                            setIsActionsClicked(
                                                !isActionsClicked
                                            );
                                            setActions(async () => {
                                                setIsEdited(false);
                                                setIsAddMoneticsClicked(false);
                                                if (
                                                    isUpdateOperation ===
                                                        true &&
                                                    isAddMoneticsClicked ===
                                                        true
                                                ) {
                                                    setIsConfirmationEditRunning(
                                                        true
                                                    );
                                                } else {
                                                    setShopId(
                                                        e.selectedRow.shopId
                                                    );
                                                    ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                        e.selectedRow.Id,
                                                        e.selectedRow.shopId,
                                                        franchiseID,
                                                        userID,
                                                        appId
                                                    );
                                                    setObjectApiUrlDissociate({
                                                        userId: userID,
                                                        shopId:
                                                            e.selectedRow
                                                                .shopId,
                                                        franchiseId: franchiseID,
                                                        appId: appId,
                                                        appId_children:
                                                            ifPeripheralAssociateObject.appId_children,
                                                        peripheralId:
                                                            e.selectedRow.Id,
                                                    });

                                                    if (
                                                        isUpdateOperation ===
                                                            true &&
                                                        isAddMoneticsClicked ===
                                                            true
                                                    ) {
                                                        setIsConfirmationEditRunning(
                                                            true
                                                        );
                                                    } else {
                                                        setShopId(
                                                            e.selectedRow.shopId
                                                        );
                                                        ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                            e.selectedRow.Id,
                                                            e.selectedRow
                                                                .shopId,
                                                            franchiseID,
                                                            userID,
                                                            appId
                                                        );
                                                        setObjectApiUrlDissociate(
                                                            {
                                                                userId: userID,
                                                                shopId:
                                                                    e
                                                                        .selectedRow
                                                                        .shopId,
                                                                franchiseId: franchiseID,
                                                                appId: appId,
                                                                appId_children:
                                                                    ifPeripheralAssociateObject.appId_children,
                                                                peripheralId:
                                                                    e
                                                                        .selectedRow
                                                                        .Id,
                                                            }
                                                        );

                                                        if (
                                                            ifPeripheralAssociateObject.isPeripheralAssociate
                                                        ) {
                                                            ErrorToast(
                                                                t(
                                                                    "Please note that you cannot archive a device associated with an application."
                                                                )
                                                            );
                                                            setIsLoading(false);
                                                        } else {
                                                            setIsModalOpened(
                                                                !isModalOpened
                                                            );
                                                        }
                                                        setMoneticId(
                                                            e.selectedRow.Id
                                                        );
                                                    }
                                                }
                                            });
                                        } else {
                                            setIsAddMoneticsClicked(false);
                                            if (
                                                isUpdateOperation === true &&
                                                isAddMoneticsClicked === true
                                            ) {
                                                setIsConfirmationEditRunning(
                                                    true
                                                );
                                                setIsLoading(false);
                                            } else {
                                                setShopId(e.selectedRow.shopId);
                                                ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                    e.selectedRow.Id,
                                                    e.selectedRow.shopId,
                                                    franchiseID,
                                                    userID,
                                                    appId
                                                );
                                                setObjectApiUrlDissociate({
                                                    userId: userID,
                                                    shopId:
                                                        e.selectedRow.shopId,
                                                    franchiseId: franchiseID,
                                                    appId: appId,
                                                    appId_children:
                                                        ifPeripheralAssociateObject.appId_children,
                                                    peripheralId:
                                                        e.selectedRow.Id,
                                                });

                                                if (
                                                    isUpdateOperation ===
                                                        true &&
                                                    isAddMoneticsClicked ===
                                                        true
                                                ) {
                                                    setIsConfirmationEditRunning(
                                                        true
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    setShopId(
                                                        e.selectedRow.shopId
                                                    );
                                                    ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                        e.selectedRow.Id,
                                                        e.selectedRow.shopId,
                                                        franchiseID,
                                                        userID,
                                                        appId
                                                    );
                                                    setObjectApiUrlDissociate({
                                                        userId: userID,
                                                        shopId:
                                                            e.selectedRow
                                                                .shopId,
                                                        franchiseId: franchiseID,
                                                        appId: appId,
                                                        appId_children:
                                                            ifPeripheralAssociateObject.appId_children,
                                                        peripheralId:
                                                            e.selectedRow.Id,
                                                    });

                                                    if (
                                                        ifPeripheralAssociateObject.isPeripheralAssociate
                                                    ) {
                                                        ErrorToast(
                                                            t(
                                                                "Please note that you cannot archive a device associated with an application."
                                                            )
                                                        );
                                                        setIsLoading(false);
                                                    } else {
                                                        setIsLoading(false);
                                                        setIsModalOpened(
                                                            !isModalOpened
                                                        );
                                                    }
                                                    setMoneticId(
                                                        e.selectedRow.Id
                                                    );
                                                }
                                            }
                                        }
                                    }}
                                    style={{ cursor: "pointer" }}
                                    height={25}
                                    width={25}
                                    fill="red"
                                />
                            </div>
                        </Tooltip>
                    ) : (
                        <Tooltip title={t("Unarchive").toString()}>
                            <div>
                                <EyeIcon
                                    className={`${classnames(
                                        "cmn_icn_unarchive ml-2",
                                        {
                                            "not-allowed-icon__clz": isLoading,
                                        }
                                    )}`}
                                    onClick={async () => {
                                        setIsLoading(true);
                                        if (
                                            isUpdateOperation === true &&
                                            isAddMoneticsClicked === true
                                        ) {
                                            setIsLoading(false);
                                            setIsConfirmationEditRunning(true);
                                        } else {
                                            setShopId(e.selectedRow.shopId);
                                            ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                e.selectedRow.Id,
                                                e.selectedRow.shopId,
                                                franchiseID,
                                                userID,
                                                appId
                                            );
                                            setObjectApiUrlDissociate({
                                                userId: userID,
                                                shopId: e.selectedRow.shopId,
                                                franchiseId: franchiseID,
                                                appId: appId,
                                                appId_children:
                                                    ifPeripheralAssociateObject.appId_children,
                                                peripheralId: e.selectedRow.Id,
                                            });

                                            if (
                                                isUpdateOperation === true &&
                                                isAddMoneticsClicked === true
                                            ) {
                                                setIsConfirmationEditRunning(
                                                    true
                                                );
                                                setIsLoading(false);
                                            } else {
                                                setShopId(e.selectedRow.shopId);
                                                ifPeripheralAssociateObject = await verifyIfPeripheralAssociate(
                                                    e.selectedRow.Id,
                                                    e.selectedRow.shopId,
                                                    franchiseID,
                                                    userID,
                                                    appId
                                                );
                                                setObjectApiUrlDissociate({
                                                    userId: userID,
                                                    shopId:
                                                        e.selectedRow.shopId,
                                                    franchiseId: franchiseID,
                                                    appId: appId,
                                                    appId_children:
                                                        ifPeripheralAssociateObject.appId_children,
                                                    peripheralId:
                                                        e.selectedRow.Id,
                                                });

                                                if (
                                                    ifPeripheralAssociateObject.isPeripheralAssociate
                                                ) {
                                                    setIsModalDeleteAssociatePeripheralOpened(
                                                        !isModalDeleteAssociatePeripheralOpened
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    setIsModalOpened(
                                                        !isModalOpened
                                                    );
                                                    setIsLoading(false);
                                                }
                                                setMoneticId(e.selectedRow.Id);
                                            }
                                        }
                                    }}
                                    style={{ cursor: "pointer" }}
                                    height={25}
                                    width={25}
                                    fill="black"
                                />
                            </div>
                        </Tooltip>
                    )}
                    <Tooltip title={t("Consult history").toString()}>
                        <div>
                            <TimePastSvgIcon
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(async () => {
                                            setIsHistoryModalOpened(true);
                                            setSelectedRows([e.selectedRow]);
                                            setIsAddMoneticsClicked(false);
                                        });
                                    } else {
                                        setIsHistoryModalOpened(true);
                                        setSelectedRows([e.selectedRow]);
                                        setIsAddMoneticsClicked(false);
                                    }
                                }}
                                className="ml-2 cmn_icn_history"
                                style={{ cursor: "pointer" }}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : e.selectedRow?.subRows === undefined && modify === false ? (
                <div className="d-flex justify-content-around">
                    <Tooltip title={t("Consult history").toString()}>
                        <div>
                            <TimePastSvgIcon
                                onClick={() => {
                                    if (isEdited === true) {
                                        setIsActionsClicked(!isActionsClicked);
                                        setActions(async () => {
                                            setIsEdited(false);
                                            setIsHistoryModalOpened(true);
                                            setSelectedRows([e.selectedRow]);
                                            setIsAddMoneticsClicked(false);
                                        });
                                    } else {
                                        setIsHistoryModalOpened(true);
                                        setSelectedRows([e.selectedRow]);
                                        setIsAddMoneticsClicked(false);
                                    }
                                }}
                                className="ml-2 cmn_icn_history"
                                style={{ cursor: "pointer" }}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
